var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-16 bg-slate-100" },
    [
      _c(
        "div",
        {
          staticClass:
            "fixed left-0 z-20 flex items-center justify-between flex-grow h-16 gap-4 px-6 border-b top-18 bg-slate-300 border-slate-400",
          style: { minWidth: "calc(100vw - 0.5rem)" }
        },
        [
          _c(
            "div",
            { staticClass: "sticky top-18 left-6" },
            [_c("BlTextTitle4", { attrs: { text: "Edit Pipeline" } })],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sticky flex items-center gap-2 top-18 right-6" },
            [
              _c("BlInputButton", {
                attrs: { label: "Add new stage" },
                on: {
                  clicked: function($event) {
                    return _vm.onCreateNewStage(2)
                  }
                }
              }),
              _vm._v(" "),
              _c("BlInputButton", {
                attrs: { type: "plain", label: "Close" },
                on: { clicked: _vm.backToBoard }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.pageLoading
        ? _c("div", { staticClass: "grid w-full h-92 place-items-center" }, [
            _c("div", { staticClass: "blum-loader" })
          ])
        : _c(
            "draggable",
            {
              staticClass: "flex gap-6 px-10 pt-3 pb-1",
              attrs: { handle: ".handle_move_position" },
              on: {
                update: function($event) {
                  $event.preventDefault()
                  return _vm.onMovePosition($event)
                }
              }
            },
            [
              _vm._l(_vm.stages, function(stage, idx) {
                return _c(
                  "div",
                  { key: stage.id, staticClass: "relative flex" },
                  [
                    !stage.is_discontinued && stage.position !== 1
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "absolute flex flex-col items-center w-6 gap-2 pt-4 pb-2 transition-all duration-300 opacity-0 -left-6 hover:opacity-100",
                            class: [
                              _vm.createLoading
                                ? "cursor-wait"
                                : "cursor-pointer"
                            ],
                            style: { height: "calc(100vh - 10rem)" },
                            on: {
                              click: function($event) {
                                return _vm.onCreateNewStage(idx + 1)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex items-center justify-center flex-shrink-0 w-6 h-6 border rounded-full border-slate-400 bg-pure-white"
                              },
                              [
                                _c("BlIcon", {
                                  staticClass: "w-4 h-4",
                                  attrs: { icon: "plus", color: "slate-6" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "flex-grow w-1 rounded bg-slate-500"
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("PipelineStage", {
                      attrs: { stage: stage, editable: "" }
                    })
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c("div", { staticClass: "flex-shrink-0 w-px" })
            ],
            2
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d46bb1d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d46bb1d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/salesPipeline/EditPipeline.vue
// module id = null
// module chunks = 